import React, { Fragment } from "react";

import FacebookIcon from "@material-ui/icons/Facebook";
import AppleIcon from "@material-ui/icons/Apple";
import AndroidIcon from "@material-ui/icons/Android";

export default function SocialLoginIcons({ socialLogin }) {
  if (
    !!socialLogin &&
    (socialLogin.google || socialLogin.facebook || socialLogin.apple)
  ) {
    return (
      <Fragment>
        {!!socialLogin.google && <AndroidIcon style={{ marginRight: 10 }} />}
        {!!socialLogin.facebook && <FacebookIcon style={{ marginRight: 10 }} />}
        {!!socialLogin.apple && <AppleIcon style={{ marginRight: 10 }} />}
      </Fragment>
    );
  }
  return null;
}
